<script>
import { Icon } from 'leaflet';
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const DEFAULT_CENTER = [35.1856, 33.3823];

export default {
  name: 'CoordinateMapModal',
  components: { LMap, LTileLayer, LMarker },
  props: {
    open: { type: Number, default: 0 },
    value: { type: String, default: '' },
    title: { type: String, default: 'Haritadan Koordinat Seç' },
    modalId: { type: String, default: 'coordinate_map_modal' },
  },
  data() {
    return {
      zoom: 12,
      center: [...DEFAULT_CENTER],
      marker: [...DEFAULT_CENTER],
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      draft: '',
    };
  },
  computed: {
    coordinateText() {
      if (!this.marker || this.marker.length !== 2) return '';
      return `${this.marker[0]}, ${this.marker[1]}`;
    },
  },
  watch: {
    open() {
      this.initFromValue(this.value);
      this.$nextTick(() => {
        this.$bvModal.show(this.modalId);
        setTimeout(() => this.resizeMap(), 300);
      });
    },
  },
  methods: {
    parseCoordinate(raw) {
      if (!raw) return null;
      const parts = String(raw).split(',').map(v => parseFloat(String(v).trim()));
      if (parts.length !== 2 || parts.some(v => Number.isNaN(v))) return null;
      return parts;
    },
    initFromValue(raw) {
      const parsed = this.parseCoordinate(raw);
      if (parsed) {
        this.center = [...parsed];
        this.marker = [...parsed];
        this.zoom = 15;
      } else {
        this.center = [...DEFAULT_CENTER];
        this.marker = [...DEFAULT_CENTER];
        this.zoom = 12;
      }
      this.draft = this.coordinateText;
    },
    resizeMap() {
      const map = this.$refs.map && this.$refs.map.mapObject;
      if (!map) return;
      map.invalidateSize();
      map.setView(this.marker, this.zoom);
    },
    onMapClick(event) {
      if (!event || !event.latlng) return;
      this.marker = [event.latlng.lat, event.latlng.lng];
      this.draft = this.coordinateText;
    },
    applyDraft() {
      const parsed = this.parseCoordinate(this.draft);
      if (!parsed) return;
      this.marker = parsed;
      this.center = [...parsed];
      this.zoom = 15;
      this.$nextTick(() => this.resizeMap());
    },
    confirm() {
      const coord = this.coordinateText;
      this.$emit('input', coord);
      this.$emit('confirm', coord);
      this.close();
    },
    clear() {
      this.marker = [...DEFAULT_CENTER];
      this.center = [...DEFAULT_CENTER];
      this.draft = '';
      this.zoom = 12;
      this.$emit('input', '');
      this.$emit('confirm', '');
      this.close();
    },
    close() {
      this.$bvModal.hide(this.modalId);
    },
    onShown() {
      this.$nextTick(() => this.resizeMap());
    },
  },
};
</script>

<template>
  <b-modal
    :id="modalId"
    :title="title"
    size="lg"
    no-close-on-backdrop
    hide-footer
    @shown="onShown"
  >
    <div class="mb-2 text-muted small">
      Haritada bir noktaya tıklayarak konum seçin.
    </div>

    <div class="input-group mb-2">
      <input
        v-model="draft"
        type="text"
        class="form-control"
        placeholder="35.1856, 33.3823"
        @keyup.enter="applyDraft"
      >
      <button class="btn btn-outline-secondary" type="button" @click="applyDraft">Git</button>
    </div>

    <l-map
      ref="map"
      :zoom="zoom"
      :center="center"
      style="height: 420px; width: 100%; z-index: 1; border-radius: 10px;"
      @click="onMapClick"
    >
      <l-tile-layer :url="url" />
      <l-marker :lat-lng="marker" />
    </l-map>

    <div class="d-flex justify-content-between align-items-center mt-3">
      <div class="small text-muted">
        Seçili: <strong>{{ coordinateText || '-' }}</strong>
      </div>
      <div>
        <b-button variant="light" class="me-1" @click="close">Vazgeç</b-button>
        <b-button variant="outline-danger" class="me-1" @click="clear">Temizle</b-button>
        <b-button variant="success" @click="confirm">Seç</b-button>
      </div>
    </div>
  </b-modal>
</template>
